<div class="mui-password-checker__control-wrapper" *ngIf="inputField?.isFocused">
  <div class="mui-password-checker__title">
    <mui-icon [font]="'fa'" [name]="isValid() ? 'lock' : 'unlock'"></mui-icon>
    <span>{{ isValid() ? strongPasswordLabel : weakPasswordLabel }}</span>
  </div>
  <div class="mui-password-checker__bars-container">
    <div *ngFor="let condition of conditions; let i = index" [ngClass]="getProgressClassForBar(i)"></div>
  </div>
  <div class="mui-password-checker__conditions">
    <div class="mui-password-checker__conditions-title">
      {{ conditionsTitle }}
    </div>
    <ul class="mui-password-checker__conditions-list">
      <li
        class="mui-password-checker__conditions-check"
        *ngFor="let condition of conditions"
        [ngClass]="{ 'condition-valid': condition.isValid, 'condition-invalid': !condition.isValid }">
        <mui-icon [font]="'fa'" [name]="condition.isValid ? 'check' : 'times'"></mui-icon>
        <span>{{ condition.conditionLabel }}</span>
      </li>
    </ul>
  </div>
</div>
